<span [ngClass]="[reduceHeight?'reduce-height':'increase-height']" style="height: {{screenHeight}}px;">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</span>